export const TELEGRAM_MESSAGE_MAX_LENGTH = 4096;
export const TELEGRAM_CAPTION_MAX_LENGTH = 1024;
export const NAVBAR_HEIGHT_PX = 70;
export const drawerWidth = 208;
